import { useState } from "react";
import { useNavigate } from "react-router-dom";
import api, { formatErr } from "@/lib/api";
import { ArrowRight, ShieldCheck } from "@phosphor-icons/react";
import { toast } from "sonner";

export default function TrustProfileSetup() {
  const nav = useNavigate();
  const [busy,setBusy] = useState(false);
  const [form,setForm] = useState({
    name:"",
    category:"",
    address:"",
    city:"",
    state:"",
    zip_code:"",
    phone:"",
    website:"",
    description:"",
    lat:null,
    lng:null,
    keywords:[],
  });

  const patch=(k,v)=>setForm(old=>({...old,[k]:v}));

  const create=async(e)=>{
    e.preventDefault();
    setBusy(true);
    try{
      const {data}=await api.post("/businesses", form);
      localStorage.setItem("active_business_id", data.id);
      toast.success("Business added for RankTrust Profile");
      nav("/app/trust-profile", {replace:true});
      window.location.reload();
    }catch(err){
      toast.error(formatErr(err));
    }finally{
      setBusy(false);
    }
  };

  return <div className="p-5 sm:p-8 lg:p-10 max-w-4xl">
    <div className="mb-7">
      <p className="label-tiny">RankTrust Reviews</p>
      <h1 className="text-3xl sm:text-4xl font-black mt-1">Create Business Trust Profile</h1>
      <p className="text-zinc-600 mt-2 max-w-2xl">Add the business information needed for its RankTrust Reviews profile. This is separate from rank tracking and does not ask for Maps keywords.</p>
    </div>
    <form onSubmit={create} className="bg-white border rounded-2xl p-5 sm:p-8 space-y-6">
      <div className="flex items-start gap-3 rounded-xl border bg-zinc-50 p-4">
        <ShieldCheck size={24} className="text-blue-700 shrink-0 mt-0.5"/>
        <div><p className="font-bold">Profile-first setup</p><p className="text-sm text-zinc-600 mt-1">RankTrust will automatically generate the branded review search targets and editorial profile structure after the business is created.</p></div>
      </div>
      <div className="grid md:grid-cols-2 gap-4">
        <Field label="Business name *"><input required className="input-field" value={form.name} onChange={e=>patch("name",e.target.value)}/></Field>
        <Field label="Primary category *"><input required className="input-field" placeholder="e.g. HVAC contractor" value={form.category} onChange={e=>patch("category",e.target.value)}/></Field>
        <Field label="City / service market *"><input required className="input-field" value={form.city} onChange={e=>patch("city",e.target.value)}/></Field>
        <Field label="State *"><input required className="input-field" value={form.state} onChange={e=>patch("state",e.target.value)}/></Field>
        <Field label="ZIP code"><input className="input-field" value={form.zip_code} onChange={e=>patch("zip_code",e.target.value)}/></Field>
        <Field label="Public business phone"><input className="input-field" value={form.phone} onChange={e=>patch("phone",e.target.value)}/></Field>
        <div className="md:col-span-2"><Field label="Official website *"><input required className="input-field" placeholder="https://example.com" value={form.website} onChange={e=>patch("website",e.target.value)}/></Field></div>
        <div className="md:col-span-2"><Field label="Address (optional for service-area businesses)"><input className="input-field" value={form.address} onChange={e=>patch("address",e.target.value)}/></Field></div>
        <div className="md:col-span-2"><Field label="Business description"><textarea rows={4} className="input-field" value={form.description} onChange={e=>patch("description",e.target.value)}/></Field></div>
      </div>
      <div className="flex justify-end"><button disabled={busy} className="btn-primary" type="submit">{busy?"Creating…":<>Create RankTrust Profile <ArrowRight size={15}/></>}</button></div>
    </form>
  </div>;
}

function Field({label,children}) {
  return <label className="block space-y-2"><span className="label-tiny block">{label}</span>{children}</label>;
}
